import axios, {AxiosResponse} from 'axios';
import {ITrainingDialogue} from '../trainings/interfaces';

export const getTrainingsDialoguesApi = (): Promise<AxiosResponse<ITrainingDialogue[]>> => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/xpedition/training/list`
  );
};

export const getTrainingDialogueApi = (id: number): Promise<AxiosResponse<ITrainingDialogue>> => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/xpedition/training/${id}`
  );
};

export const createTrainingDialogueApi = (
  dialogue: ITrainingDialogue,
  lang: string
): Promise<AxiosResponse<ITrainingDialogue>> => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/xpedition/training/add`,
    {
      name: dialogue.dialogName,
      userDate: dialogue.dialogUserDate,
      language: lang
    }
  );
};

export const editTrainingDialogueApi = (
  dialogue: ITrainingDialogue
): Promise<AxiosResponse<{ value: string }>> => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/xpedition/training/edit`,
    {
      id: dialogue.dialogId,
      name: dialogue.dialogName,
      userDate: dialogue.dialogUserDate
    }
  );
};
